import { Center, Stack, Text } from '@mantine/core'
import { IconFileOff } from '@tabler/icons-react'

export default function PageEmpty() {
  return (
    <Center py="xl" style={{ minHeight: '300px' }}>
      <Stack align="center" gap="md">
        <div
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#f3f4f6',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconFileOff size={40} color="#9ca3af" />
        </div>
        <Stack align="center" gap={4}>
          <Text size="lg" fw={600} style={{ color: '#6b7280' }}>
            还没有报告订单
          </Text>
          <Text size="sm" c="dimmed">
            查询报告后会在这里显示
          </Text>
        </Stack>
      </Stack>
    </Center>
  )
}
